var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox_container" }, [
    _c("label", { staticClass: "customi_label", attrs: { for: "cbx" } }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.checked,
            expression: "checked"
          }
        ],
        staticClass: "invisible customi_input",
        attrs: { type: "checkbox" },
        domProps: {
          checked: Array.isArray(_vm.checked)
            ? _vm._i(_vm.checked, null) > -1
            : _vm.checked
        },
        on: {
          change: function($event) {
            var $$a = _vm.checked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.checked = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checked = $$c
            }
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "customi_div checkbox", on: { click: _vm.toggle } },
        [
          _c(
            "svg",
            { staticClass: "customi_svg", attrs: { viewBox: "0 0 20 20" } },
            [
              _c("path", {
                staticClass: "svg_bg",
                attrs: {
                  d:
                    "M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"
                }
              }),
              _vm._v(" "),
              _c("polyline", {
                staticClass: "svg_top checkbox_check",
                attrs: { points: "4 11 8 15 16 6" }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.label))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Misc/checkBox.vue?vue&type=template&id=72a759be&
// module id = null
// module chunks = 